import { render, staticRenderFns } from "./matchHDPOU1X2Odds.vue?vue&type=template&id=4ccf5298&lang=pug&"
import script from "./matchHDPOU1X2Odds.vue?vue&type=script&lang=js&"
export * from "./matchHDPOU1X2Odds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports